import React from "react";
import { colorForText } from "../utilities/colorutils";

const BrandIcon = ({ name, iconUrl, size }: { name: string, iconUrl?: string, size?: number }) => {
  const maxSize = size ?? 75;
  const fontSize = maxSize * 0.6;

  if (iconUrl) return (<div title={name} className="brand-symbol-wrapper"><img src={iconUrl} title={name} style={{ maxWidth: maxSize }} /></div>);

  const backgroundColor = colorForText(name, 0.9);

  return (<div title={name} className="flex align-center justify-center" style={{
    width: maxSize,
    height: maxSize,
    backgroundColor,
    fontSize,
    fontWeight: 500,
    color: "white"
  }}>{name.substring(0, 1)}</div>);
};

export default BrandIcon;